import React, { useEffect } from 'react';
import useNewBrandContext from 'contexts/new-brand.context';
import { STORAGE_KEYS } from 'utils/constants';
import { FileUploader } from '@cokitchen/cokitchen-components';

const CreateBrandImages = () => {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) as string;
  const { createBrandForm, setCreateBrandForm, setDisabled } = useNewBrandContext();

  useEffect(() => {
    const { images = [], logo = '' } = createBrandForm;
    setDisabled(images?.length === 0 || !logo);
  }, [createBrandForm]);

  return (
    <div>
      <div className='mb-8'>
        <FileUploader
          token={token}
          fileUrls={createBrandForm?.images}
          label={<h3 className='font-medium mb-2'>Add brand image </h3>}
          setFileUrls={(k) => setCreateBrandForm({ ...createBrandForm, images: k })}
        />
      </div>
      <div>
        <FileUploader
          token={token}
          fileUrls={createBrandForm.logo ? [createBrandForm.logo] : []}
          label={<h3 className='font-medium mb-2'>Add brand logo </h3>}
          setFileUrls={(k) => setCreateBrandForm({ ...createBrandForm, logo: k[0] })}
        />
      </div>
    </div>
  );
};

export default CreateBrandImages;
